import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Button, Tag, TagProps } from 'rsuite'
import LegacyTagIcon from '@rsuite/icons/legacy/Tag'

import styles from '../styles/Tag.module.less'

interface UseCaseTagProps extends TagProps {
  label: string
  onClick: () => void
  isActive?: boolean
}

const UseCaseTag: FC<UseCaseTagProps> = (props) => {
  const { size = 'lg', label, className = '', isActive, ...rest } = props
  const { t } = useTranslation('useCase')

  const activeClassName = isActive ? styles['active-use-case'] : ''

  return (
    <Tag
      className={`${styles.tag} ${styles['use-case']} ${styles.bordered} ${className} ${activeClassName}`}
      size={size}
      as={Button}
      {...rest}
    >
      <LegacyTagIcon />
      <span>
        {t(label)}
      </span>
    </Tag>
  )
}

export default UseCaseTag
